import { AuthType, AUTHENTICATION_PROVIDER } from '../types';

export const getAuthenticationProvider = (): AuthType => {
	if (localStorage.getItem(AUTHENTICATION_PROVIDER) === AuthType.Forge)
		return AuthType.Forge;
	return AuthType.Auth0;
};
